import {request} from "../request/request";

const discipline = {
  getAll: () => request.read('/discipline', null, true),
  getOne: (disciplineId) => request.read(`/discipline/${disciplineId}`, null, true),
};

export {discipline};